import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

import { SplitTargetPayload } from '../entities/ShipmentOrderLegRun.entity';

import { SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY } from './useQueryShipmentOrderLegRuns';
import { SHIPMENT_ORDERS_QUERY_KEY } from './useQueryShipmentOrders';

export const useMutationShipmentOrderLegRun = () => {
  const queryClient = useQueryClient();

  return {
    restoreSplitLegRun: useMutation({
      mutationFn: (id: number) => axios.post(`/api/v5/shipment_order_leg_runs/${id}/restore_split`),

      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: [SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY] });
        // 復元で伝票の was_split 状態が変わるため伝票キャッシュも破棄する
        void queryClient.invalidateQueries({ queryKey: [SHIPMENT_ORDERS_QUERY_KEY] });
      }
    }),
    restoreSplitLegRuns: useMutation({
      mutationFn: (data: { startOn: string, endOn: string }) => axios.post('/api/v5/shipment_order_leg_runs/restore_splits',
                                                     { start_on: data.startOn, end_on: data.endOn }),

      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: [SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY] });
        // 一括復元で伝票の was_split 状態が変わるため伝票キャッシュも破棄する
        void queryClient.invalidateQueries({ queryKey: [SHIPMENT_ORDERS_QUERY_KEY] });
      }
    }),
    splitLegRun: useMutation({
      mutationFn: (args: { id: number; splits: SplitTargetPayload[] }) =>
        axios.post(`/api/v5/shipment_order_leg_runs/${args.id}/split`, { splits: args.splits }),

      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: [SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY] });
        // 分割で伝票の was_split 状態が変わるため伝票キャッシュも破棄する
        void queryClient.invalidateQueries({ queryKey: [SHIPMENT_ORDERS_QUERY_KEY] });
      }
    }),
  };
};
